import type {ValueOrderEntitlementsModel} from "@reva/shared/value-order";

import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";

/**
 * API-Interface für die Freischaltungen beim ValueAG-Auftraggeber (GET {@link RevaApi.PATH_VALUE_ORDERS_ENTITLEMENTS}).
 * Fragt bewusst ohne `valueClientGuid` – reva-rest nimmt dann die Client-ID der Lizenz des angemeldeten Benutzers,
 * also genau die, mit der auch das Beauftragen läuft. Der Parameter ist Admins vorbehalten.
 */
export class ValueOrderEntitlementsApiInterface extends SimpleApiInterface<ValueOrderEntitlementsModel> {
    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUE_ORDERS_ENTITLEMENTS]);
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<ValueOrderEntitlementsModel> {
        return executor.fetchGET(url, credentials);
    }
}
